export default __webpack_public_path__ + "static/media/dungeon.5341f648.svg";